<template>
  <div class="route-cargos">
    <a-spin v-if="loading" class="route-cargos__spin" />

    <a-empty
      v-else-if="!items.length"
      class="route-cargos__empty"
      description="Nenhuma carga encontrada."
    />

    <template v-else>
      <div
        v-for="cargo in visibleItems"
        :key="cargo.id"
        class="route-cargos__row"
      >
        <a-icon type="inbox" class="route-cargos__row-icon" />

        <span class="route-cargos__info">
          <span class="route-cargos__label">Tipo carga:</span>
          {{ cargo.tipoCarga }}
          <span class="route-cargos__separator">•</span>
          <span class="route-cargos__label">Tipo:</span>
          {{ cargo.tipo }}
        </span>

        <div class="route-cargos__row-actions">
          <StatusBadge :label="cargo.status" :active="isActive(cargo)" />
        </div>
      </div>

      <a
        v-if="hasMore"
        class="route-cargos__show-all"
        href="#"
        @click.prevent="showAll = !showAll"
      >
        {{ showAll ? "Exibir menos" : "Exibir todos" }}
        <a-icon :type="showAll ? 'up' : 'down'" />
      </a>
    </template>
  </div>
</template>

<script>
import StatusBadge from "@/shared/components/StatusBadge.vue";
import { FREIGHT_TABLE_STATUS } from "../../constants/freightTableStatus";

const COLLAPSED_LIMIT = 4;

export default {
  name: "FreightTableRouteCargos",
  components: { StatusBadge },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showAll: false,
    };
  },
  computed: {
    visibleItems() {
      return this.showAll ? this.items : this.items.slice(0, COLLAPSED_LIMIT);
    },
    hasMore() {
      return this.items.length > COLLAPSED_LIMIT;
    },
  },
  methods: {
    isActive(cargo) {
      return cargo.statusValor === FREIGHT_TABLE_STATUS.ATIVA;
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.route-cargos {
  &__spin,
  &__empty {
    display: block;
    padding: 24px;
    text-align: center;
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #fff;
    border: 1px solid @color-bg-subtle;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 8px;
  }

  &__row-icon {
    color: @color-primary;
    flex-shrink: 0;
  }

  &__info {
    font-size: 14px;
    color: @color-text-dark;
    min-width: 0;
  }

  &__label {
    color: @color-text-light;
  }

  &__separator {
    color: @color-text-muted;
    margin: 0 6px;
  }

  &__row-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
    padding-left: 8px;
    flex-shrink: 0;
  }

  &__show-all {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: @color-primary;
    font-weight: 500;
    margin-top: 8px;

    &:hover,
    &:focus {
      color: @color-primary-hover;
      text-decoration: none;
    }
  }
}
</style>
